import { createFileRoute } from '@tanstack/react-router';

import { TelehealthPage, telehealthBeforeLoad } from '@/pages/settings/telehealth';

export const Route = createFileRoute('/settings/telehealth')({
    beforeLoad: telehealthBeforeLoad,
    component: TelehealthPage,
});
